import { TransportOperatorService } from 'src/app/angularJS/services/transport-operator/transport-operator.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
  * A Controller to handle the creation of transport operators.
*/
export class CreateOperatorController {
  public static $inject = [
    'transportOperatorService',
    'ACTToolbarService',
    '$state',
    'userService',
    'UserMessages',
    '$translate',
    '$rootScope',
    'statusConstants',
    'LinkBuilder',
    'breadcrumbService',
    '$sanitize'
  ];

  public transportOperator: InterACT.Interfaces.TransportOperators.TransportOperator;
  public name: string;
  public tradingName: string;
  public externalReferences: Array<InterACT.Interfaces.ITransportOperatorExternalReference>;
  private currentLocale: string;

  constructor(
    private transportOperatorService: TransportOperatorService,
    private toolbarService: ACTToolbarService,
    private $state: ng.ui.IStateService,
    private userService: UserService,
    private UserMessages: UserMessagesService,
    private $translate: ng.translate.ITranslateService,
    private $rootScope,
    private statusConstants: InterACT.Interfaces.IStatusConstants,
    private linkBuilder: LinkBuilder,
    private breadcrumbService: BreadcrumbService,
    private sanitize: any
  ) {
    this.activate();
  }

  /**
   * Allows a user to create a transport operator
   */
  public create = () => {
    const operator = JSON.parse(JSON.stringify(this.transportOperator));
    operator.tradingName = [];
    operator.schemes = [];
    operator.externalReference = [];

    this.$rootScope.showSpinner = true;

    if (!this.tradingName) {
      operator.tradingName.push(this.sanitize(this.name));
    } else {
      operator.tradingName.push(this.sanitize(this.tradingName));
    }

    operator.name = {};
    operator.name[this.currentLocale] = this.sanitize(this.name);
    operator.status = this.statusConstants.ACTIVE;

    const externalReferences = JSON.parse(JSON.stringify(this.externalReferences));
    externalReferences.forEach((externalReference) => {
      externalReference.scheme = {
        abbreviation: this.userService.selectedScheme.reference,
        link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id)
      };
      operator.schemes.push({
        abbreviation: externalReference.scheme.abbreviation,
        link: externalReference.scheme.link
      });
      operator.externalReference.push(externalReference);
    });

    operator.source = { manualEntry: true };

    if (operator.fields.hasOwnProperty('OID') && operator.fields.OID === '') {
      delete operator.fields.OID;
    }

    if (operator.fields.hasOwnProperty('SPID') && operator.fields.SPID === '') {
      delete operator.fields.SPID;
    }

    this.transportOperatorService.create(operator).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('TOAST_MESSAGE.OPERATOR.CREATED', {
        name: operator.name[this.currentLocale]
      });
      this.goToOperators();
    });
  }

  /**
   * Takes you back to the operators list view
   */
  public goToOperators = () => {
    this.$state.go('operators');
  }

  /**
   * Sets name property on the toolbar
   */
  private activate() {
    this.transportOperator = <any>{};
    this.externalReferences = [];
    this.currentLocale = this.$translate.use();
    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle('OPERATORS_CREATE');
    });

    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.OPERATORS',
        sref: 'operators'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.CREATE',
        sref: 'operators-create'
      }
    ]);

  }
}